module.exports = __webpack_public_path__ + "img/bg.ec47a48e.jpg";